import { Clock, UserCheck } from 'lucide-react';
import { formatDateTime } from '@/utils/format';

export interface MasterAuditInfoProps {
  createdBy?:       string | null;
  createdByName?:   string | null;
  createdDate?:     string | null;
  modifiedBy?:      string | null;
  modifiedByName?:  string | null;
  modifiedDate?:    string | null;
  deletedBy?:       string | null;
  deletedByName?:   string | null;
  deletedDate?:     string | null;
}

const Row = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-start gap-2 py-2 border-b border-gray-100 dark:border-gray-700 last:border-0">
    <span className="text-xs text-gray-500 dark:text-gray-400 w-36 flex-shrink-0 pt-0.5">{label}</span>
    <span className="text-xs text-gray-800 dark:text-gray-200 font-medium">{value}</span>
  </div>
);

export const MasterAuditInfo = ({
  createdBy, createdByName, createdDate,
  modifiedBy, modifiedByName, modifiedDate,
  deletedBy, deletedByName, deletedDate,
}: MasterAuditInfoProps) => (
  <div className="space-y-4 max-w-lg">
    <div className="flex items-center gap-2 text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
      <Clock size={15} className="text-brand-500" />
      Creation
    </div>
    <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg px-4 py-1 mb-4">
      <Row label="Created By"   value={createdByName ?? createdBy ?? '—'} />
      <Row label="Created Date" value={formatDateTime(createdDate)} />
    </div>

    <div className="flex items-center gap-2 text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
      <UserCheck size={15} className="text-brand-500" />
      Last Modified
    </div>
    <div className="bg-gray-50 dark:bg-gray-800/50 rounded-lg px-4 py-1 mb-4">
      <Row label="Modified By"   value={modifiedByName ?? modifiedBy ?? '—'} />
      <Row label="Modified Date" value={formatDateTime(modifiedDate)} />
    </div>

    {(deletedBy || deletedByName || deletedDate) && (
      <>
        <div className="text-sm font-semibold text-rose-600 dark:text-rose-400 mb-3">
          Deletion Record
        </div>
        <div className="bg-rose-50 dark:bg-rose-900/20 rounded-lg border border-rose-100 dark:border-rose-800 px-4 py-1">
          <Row label="Deleted By"   value={deletedByName ?? deletedBy ?? '—'} />
          <Row label="Deleted Date" value={formatDateTime(deletedDate)} />
        </div>
      </>
    )}
  </div>
);
